import { model as router } from '!/router'
import { useUnit } from 'effector-react'

type SocialAuthProvider = 'apple' | 'facebook' | 'google'

interface SocialAuthUrlParams {
  redirectUrl?: string
}

export const buildSocialAuthUrl = (
  provider: SocialAuthProvider,
  { redirectUrl }: SocialAuthUrlParams = {}
) => {
  const params = new URLSearchParams({
    marketingConsent: 'true',
  })

  if (redirectUrl) {
    params.set('redirectUrl', redirectUrl)
  }

  return `/api/web/auth/${provider}?${params.toString()}`
}

export const useGetRedirectUrl = () => {
  const locationHostName = location?.origin
  const pathname = useUnit(router.$pathname)
  return `${locationHostName}${pathname}`
}
